export const menuMultipleStyles = {
  maxHeight: '360px',
  overflowY: 'auto',
  width: '280px',
  margin: 0,
  borderTop: 0,
  background: '#303030',
  position: 'absolute',
  zIndex: 1000,
  listStyle: 'none',
  padding: 0,
  // left: '100px',
  color: 'rgba(255, 255, 255, 0.92)',
};
